import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { fontRobotoCondensed } from "shared/lib/styles";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  inline-size: 100%;
  padding-block: 20px;
  padding-inline: 16px;

  border: 1px solid #dfdfdf;
  border-radius: 4px;

  background-color: #f8f8f8;
`;

export const Title = styled.p`
  padding-block-end: 16px;

  border-block-end: 1px solid #dfdfdf;

  color: #000000;
  font-weight: 400;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
`;

type ToggleProps = {
  $isExpand: boolean;
};

export const Toggle = styled.div<ToggleProps>`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;

  color: #2c4692;
  font-weight: 400;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};

  cursor: pointer;

  svg {
    ${props =>
      props.$isExpand &&
      css`
        transform: rotate(180deg);
      `}
  }
`;
